// VERSION : 0.0.1
// AUTHOR : VIGNESH
// LAST EDIT : VIGNESH
// MODIFIED DATE: 07-12-2025
// LAST CHANGED : ADDED COMMENT LINES
import MonthlyWiseInterestSummaryReportAction from './month-wise-interest-summary-report.type';

/*************** Get Month Wise Interest Summary Report Start ******************/
export const getMonthWiseInterestSummaryReportStart = (getData: any) => ({
	type: MonthlyWiseInterestSummaryReportAction.GET_MONTH_WISE_INTEREST_SUMMARY_REPORT_LIST_START,
	payload: getData,
});

export const getMonthWiseInterestSummaryReportSuccess = (successData: any) => ({
	type: MonthlyWiseInterestSummaryReportAction.GET_MONTH_WISE_INTEREST_SUMMARY_REPORT_LIST_SUCCESS,
	payload: successData,
});

export const getMonthWiseInterestSummaryReportFailure = (failureData: any) => ({
	type: MonthlyWiseInterestSummaryReportAction.GET_MONTH_WISE_INTEREST_SUMMARY_REPORT_LIST_FAILURE,
	payload: failureData,
});

export const getMonthWiseInterestSummaryReportResponseReset = () => ({
	type: MonthlyWiseInterestSummaryReportAction.GET_MONTH_WISE_INTEREST_SUMMARY_REPORT_LIST_RESPONSE_RESET,
});

export const getMonthWiseInterestSummaryReportResponseChanged = () => ({
	type: MonthlyWiseInterestSummaryReportAction.GET_MONTH_WISE_INTEREST_SUMMARY_REPORT_LIST_RESPONSE_CHANGED,
});
/*************** Get Month Wise Interest Summary Report End ******************/

/*************** Get Month Wise Interest Summary Report Excel Start ******************/
export const getMonthWiseInterestSummaryReportExcelStart = (getData: any) => ({
	type: MonthlyWiseInterestSummaryReportAction.GET_MONTH_WISE_INTEREST_SUMMARY_REPORT_EXCEL_START,
	payload: getData,
});

export const getMonthWiseInterestSummaryReportExcelSuccess = (successData: any) => ({
	type: MonthlyWiseInterestSummaryReportAction.GET_MONTH_WISE_INTEREST_SUMMARY_REPORT_EXCEL_SUCCESS,
	payload: successData,
});

export const getMonthWiseInterestSummaryReportExcelFailure = (failureData: any) => ({
	type: MonthlyWiseInterestSummaryReportAction.GET_MONTH_WISE_INTEREST_SUMMARY_REPORT_EXCEL_FAILURE,
	payload: failureData,
});

export const getMonthWiseInterestSummaryReportExcelResponseReset = () => ({
	type: MonthlyWiseInterestSummaryReportAction.GET_MONTH_WISE_INTEREST_SUMMARY_REPORT_EXCEL_RESPONSE_RESET,
});

export const getMonthWiseInterestSummaryReportExcelResponseChanged = () => ({
	type: MonthlyWiseInterestSummaryReportAction.GET_MONTH_WISE_INTEREST_SUMMARY_REPORT_EXCEL_RESPONSE_CHANGED,
});
/*************** Get Month Wise Interest Summary Report Excel End ******************/
